import { FC } from 'react';

const LinkIcon: FC = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.9846 24.4999L15.2421 25.2424C14.1138 26.3525 12.5926 26.9718 11.0097 26.9653C9.42693 26.9589 7.91077 26.3273 6.79154 25.208C5.67231 24.0888 5.04067 22.5726 5.03423 20.9898C5.02778 19.407 5.64705 17.8858 6.75713 16.7574L9.77088 13.7499C10.8519 12.6667 12.306 12.0375 13.8356 11.9911C15.3653 11.9446 16.8548 12.4844 17.9996 13.4999"
                stroke="#0A163C"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.015 7.50012L16.7575 6.75762C17.8858 5.64754 19.4071 5.02827 20.9899 5.03472C22.5727 5.04116 24.0889 5.67279 25.2081 6.79203C26.3273 7.91126 26.959 9.42742 26.9654 11.0102C26.9718 12.5931 26.3526 14.1143 25.2425 15.2426L22.2288 18.2564C21.1469 19.3387 19.6924 19.9668 18.1628 20.0121C16.6331 20.0574 15.144 19.5165 14 18.5001"
                stroke="#0A163C"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export { LinkIcon };
